import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconHomeOutline } from '@saucelabs/ds-icons';

import { pressMobileDeviceHardwareButton } from '../../../actions';
import { MOBILE_DEVICE_HARDWARE_BUTTON_TYPES } from '../../../constants';
import GenericButton from './GenericButton';
import selectors from '../selectors';

const HomeButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const { deviceToolsDisabled } = useSelector(selectors.toolbarButtonSelector);

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconHomeOutline}
      label="Home"
      onPress={() => {
        void dispatch(
          pressMobileDeviceHardwareButton(MOBILE_DEVICE_HARDWARE_BUTTON_TYPES.HOME),
        );
      }}
      role={role}
    />
  );
};

HomeButton.displayName = 'HomeButton';

export default HomeButton;
